<template>
    <vue-content-loading class="kanban-column-loading h-100 rounded mr-2"
                         v-bind:width="300"
                         v-bind:height="height">
        <rect x="0" y="0" rx="2" ry="2" width="300" height="100%"></rect>
    </vue-content-loading>
</template>

<script>
import VueContentLoading from "vue-content-loading";

export default {
    name: "KanbanColumnLoading",
    components: {
        VueContentLoading,
    },
    data () {
        return {
            height: 800,
        };
    },
    computed: {

    },
    methods: {

    },
    mounted () {
        this.height = window.innerHeight - 52.5;
    },
}
</script>

<style lang="scss" scoped>
.kanban-column-loading {
    min-width: 300px;
    width: 300px;
    height: 100%;
}
</style>
